import actions from '@/store/promotions/actions';

const promotionsModule = {
  state: () => ({
    promoCodes: [],
    promoCodeDetails: null,
    promoCodesTotal: null,
    foreverClubCards: [],
    foreverClubCardsTotal: null,
    foreverClubCard: {},
    categories: [],
    templates: [],
    promoSections: [],
    selectedTemplate: {},
  }),
  mutations: {
    GET_COUPONS_SUCCESS(state, data) {
      state.promoCodes = data.promoCodes;
      state.promoCodesTotal = data.meta.count;
    },
    GET_ONE_PROMO_CODE_SUCCESS(state, data) {
      state.promoCodeDetails = data;
    },
    GET_FOREVER_CLUB_CARDS_SUCCESS(state, data) {
      state.foreverClubCards = data.data;
      state.foreverClubCardsTotal = data.total;
    },
    GET_FOREVER_CLUB_CARD_INFO_SUCCESS(state, data) {
      state.foreverClubCard = data;
    },
    GET_PROMO_CATEGORIES_SUCCESS(state, data) {
      state.categories = data.categories;
    },
    GET_TEMPLATES_SUCCESS(state, data) {
      state.templates = data.data;
    },
    SELECT_BANNER_TEMPLATE_SUCCESS(state, data) {
      state.selectedTemplate = data;
    },
    GET_PROMO_SECTIONS_SUCCESS(state, data) {
      state.promoSections = data;
    },
  },
  actions,
  namespaced: true,
};

export default promotionsModule;
